import { render, staticRenderFns } from "./detail-ticket-collaborator.vue?vue&type=template&id=1f0b7476&scoped=true&"
import script from "./detail-ticket-collaborator.vue?vue&type=script&lang=js&"
export * from "./detail-ticket-collaborator.vue?vue&type=script&lang=js&"
import style0 from "../DetailTiket.scss?vue&type=style&index=0&id=1f0b7476&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b7476",
  null
  
)

export default component.exports